import { Chip, styled } from '@mui/material';

export const AssigneesWrapper = styled('li')(() => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  gap: 'var(--spacing-small)',
  justifyContent: 'flex-start',
}));

export const StyledChip = styled(Chip)(() => ({
  fontWeight: 'var(--font-weight-button-label)',
}));
